export const FEATURE_GROW_3284_SEEDANCE_LAUNCH_BANNER = 'grow-3284-seedance-launch-banner'
export const FEATURE_GROW_3265_HOMEPAGE_TRIAL_BAR = 'grow-3265-homepage-trial-bar'
export const FEATURE_GROW_3276_HOMEPAGE_VIDEO_GENERATOR_FIRST =
  'grow-3276-homepage-video-generator-first'
export const FEATURE_GROW_3264_HOMEPAGE_MARKETING_SUITE_BLOCK =
  'grow-3264-homepage-marketing-suite-block'
export const FEATURE_GROW_3279_HOMEPAGE_MUSIC_GENERATOR_BLOCK =
  'grow-3279-homepage-music-generator-block'
export const FEATURE_GROW_3266_HOMEPAGE_SEEDANCE_HOVER_VIEW =
  'grow-3266-homepage-seedance-hover-view'
